import React from "react";
import "../global.scss";

import ImgPF1 from "../../../assets/images/para-voce/img-PF1.png";
import { Link } from "react-router-dom";

export const TabRecebimentoSalarios = () => {
  return (
    <div className="tab-content">
      <div className="left">
        <div className="content">
          <h1>Recebimento de salários de empresas no exterior</h1>
          <p>
            Com o crescimento da tecnologia, muitas empresas contratam mão de
            obra qualificada em diversos países. Receber salário de empresas
            estrangeiras envolve alguns aspectos importantes que devem ser
            considerados, tanto para o empregado quanto para o empregador.
            Receber salário de empresas estrangeiras requer atenção a detalhes
            legais e financeiros. Planejamento e assessoria profissional são
            essenciais para garantir uma transação tranquila e vantajosa para
            ambas as partes. Fique atento à pontos importantes:
          </p>
        </div>
        <div className="content">
          <h2 className="title">Tributação</h2>
          <p>
            <span className="title-span">
              Imposto de Renda no país de residência:{" "}
            </span>{" "}
            O salário recebido do exterior, geralmente, é considerado renda
            tributável no país de residência do empregado. É fundamental
            declarar esses valores à Receita Federal e verificar as regras de
            tributação aplicáveis. Em alguns casos, pode haver acordos de
            bitributação entre países para evitar a dupla tributação.
          </p>
          <p>
            <span className="title-span">Impostos no país da empresa: </span>{" "}
            Dependendo da legislação do país da empresa, pode haver a
            necessidade de pagar impostos localmente. É importante se informar
            sobre as regras tributárias do país de origem do salário.
          </p>
        </div>
        <div className="content">
          <h2 className="title">Legislação</h2>
          <p>
            <span className="title-span">Legislação trabalhista: </span>É
            importante entender qual legislação trabalhista se aplica ao
            contrato de trabalho, se a do país de residência do empregado ou a
            do país da empresa. Isso impacta em questões como férias, licenças e
            direitos trabalhistas em geral.
          </p>
          <p>
            <span className="title-span">Compliance legal:</span> A empresa
            precisa estar em conformidade com as leis trabalhistas e tributárias
            tanto do país de origem quanto do país de residência do empregado.
            Isso pode envolver a contratação de serviços especializados em folha
            de pagamento internacional.
          </p>
          <p>
            <span className="title-span">Documentação:</span> Manter registros
            detalhados de todos os pagamentos e transações é essencial para
            garantir a conformidade legal.
          </p>
        </div>
      </div>
      <div className="right">
        <img src={ImgPF1} alt="" />
        <div className="vantagens">
          <h2>Vantagens de utilizar a Cobalt</h2>
          <p>
            <span className="title-span">Plataformas de Pagamento Online</span>
            Plataformas como a da Cobalt, que oferecem transferências
            internacionais com taxas, geralmente, mais competitivas que as dos
            bancos tradicionais.
          </p>
          <p>
            <span className="title-span">Transparência</span>
            Aqui na Cobalt, não há taxas escondidas como taxas de saque, taxas
            de conversão e IOF. Todos os custos das transações são informados
            antes do fechamento do câmbio.
          </p>
          <p>
            <span className="title-span">Proteção Cambial</span>O valor recebido
            em moeda local pode variar de acordo com a flutuação da taxa de
            câmbio. Utilizar produtos cambiais, como contratos a termo, pode
            ajudar a mitigar esse risco.
          </p>

          <Link to={"/cadastro"} className="btn-abrir-conta">Abra agora a sua conta</Link>
        </div>
      </div>
    </div>
  );
};
